import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useSelectedAccount } from '@ibk/shared-auth';
export function useSynergyBannerTracking() {
    const { selectedAccount } = useSelectedAccount();
    const companyName = selectedAccount?.companyName || '';
    const trackSynergyBanner = useCallback((params) => {
        datadogRum.addAction(params.action_name, {
            company_name: companyName,
        });
    }, [companyName]);
    return { trackSynergyBanner };
}
